<template>
  <div>
    <h3 class="color-darkblue">Parts</h3>
    <div class="table-responsive-sm mt-4">
      <table class="table table-bordered table-sm" style="table-layout: fixed;">
        <thead>
          <tr class="table-primary">
            <th scope="col">Part Number</th>
            <th scope="col" class="text-right">Quantity Claimed</th>
            <th v-if="canViewPartCalimedPrice" scope="col" class="text-right">Part Claimed Price</th>
            <th scope="col" class="text-right">Dealer Price</th>
            <th scope="col" class="text-right">Total Part Claimed Amount</th>
            <th scope="col" class="text-right">Quantity Processed</th>
            <th scope="col" class="text-right">Price Processed</th>
            <th scope="col" class="text-right">Total Part Processed Amount</th>
            <th scope="col" class="text-right">Handling %</th>
            <th scope="col" class="text-right">Claimed Handling Amount</th>
            <th scope="col" class="text-right">Processed Handling Amount</th>
            <th scope="col" class="text-right">Total Claimed</th>
            <th scope="col" class="text-right">Total Processed</th>
            <th scope="col" class="text-right">Attachment</th>
            <th scope="col" style="width: 55px;"> Action </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in rows" :key="index">

            <td>
              <v-select v-model="row.part" :id="'part_' + index" :name="'part_' + index" label="text"
                :options="componentArr" @search="onSearchComponent" placeholder="Select Part"
                class='custom-ci-auto-search contract-data'
                @input="populateDescription(index), populatePartClaimedPrice(index)">
                <template slot="no-options">
                  Search Parts...
                </template>
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.text }}
                  </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.text }}
                  </div>
                </template>
              </v-select>
              <div class="field-error">{{ row.part_number_error_msg }}</div>
            </td>
            <td>
              <input type="number" placeholder="Quantity Claimed" v-model="row.qty_claimed" :id="'qty_claimed' + index"
                style="width:99% !important" :name="'qty_claimed' + index" class="vgt-input text-right"
                v-on:keyup="calculateClaimAmount(index)">
              <div class="field-error">{{ row.quantity_claimed_error_msg }}</div>
            </td>
            <td v-if="canViewPartCalimedPrice">
              <input type="text" placeholder="Part Claimed Price" v-model="row.part_claimed_price"
                v-on:keyup="calculateClaimAmount(index)" :id="'part_claimed_price' + index"
                :name="'part_claimed_price' + index" style="width:99% !important" class="vgt-input text-right"
                :disabled="true">
              <div class="field-error">{{ row.part_claimed_price_error_msg }}</div>
            </td>
            <td>
              <input type="number" placeholder="User Input Price" v-model="row.user_input_price"
                :id="'user_input_price' + index" :name="'user_input_price' + index" style="width:99% !important"
                class="vgt-input text-right" v-on:keyup="calculateClaimAmount(index)">
              <div class="field-error">{{ row.part_claimed_price_error_msg }}</div>
            </td>
            <td>
              <input type="text" disabled placeholder="Processed" v-model="row.processed" id="processed" name="processed"
                style="width:99% !important" class="vgt-input text-right">
            </td>
            <td>
              <input type="number" placeholder="Quantity Processed" v-model="row.processed_part_quantity" :id="'processed_part_quantity' + index"
                style="width:99% !important" :name="'processed_part_quantity' + index" class="vgt-input text-right"
                v-on:keyup="calculateProcessedLineItemAmount(index)">
            </td>
            <td>
              <input type="number" placeholder="Price Processed" v-model="row.processed_part_price" :id="'processed_part_price' + index"
                style="width:99% !important" :name="'processed_part_price' + index" class="vgt-input text-right"
                v-on:keyup="calculateProcessedLineItemAmount(index)">
            </td>
            <td>
              <input type="number" placeholder="Total Part Processed Amount" v-model="row.totalPartProcessedAmount" :id="'totalPartProcessedAmount' + index"
                style="width:99% !important" :name="'totalPartProcessedAmount' + index" class="vgt-input text-right">
            </td>
            <td>
              <input type="text" disabled placeholder="Handling %" v-model="row.handling" id="handling" name="handling"
                style="width:99% !important" class="vgt-input text-right">
            </td>
            <td>
              <input type="text" disabled placeholder="Paid %" v-model="row.handling_amount" id="paid" name="paid"
                style="width:99% !important" class="vgt-input text-right">
            </td>
            <td>
              <input type="text" disabled placeholder="Paid %" v-model="row.processed_handling_amount" id="paid" name="paid"
                style="width:99% !important" class="vgt-input text-right">
            </td>
            <td>
              <input type="text" disabled placeholder="Total %" v-model="row.total" id="Total" name="Total"
                style="width:99% !important" class="vgt-input text-right">
            </td>
            <td>
              <input type="text" disabled placeholder="Total %" v-model="row.processed_total" id="Total" name="Total"
                style="width:99% !important" class="vgt-input text-right">
            </td>
            <td>
              <template v-if="row.partAttachmentPath == null">
                <input type="file" id="Total" name="partAttachment" @change="event => partAttachmentUpload(index, event)"
                  class="vgt-input text-right" style="width:99% !important" :required="row.attachmentRequired"
                  ref="partAttachment">
                <div class="field-error">{{ row.partAttachmentError }}</div>
                <button class="btn btn-primary" id="uploadButton" style="margin: 4px;"
                  v-on:click.prevent="uploadAttachment('partAttachment', index)">
                  <i class="fp-upload"> </i> Upload
                </button>
              </template>
              <template v-else>
                <i v-if="row.partAttachmentPath.extension == 'pdf'" class="fp-pdf-icon"></i>
                <i v-if="row.partAttachmentPath.extension == 'doc' || row.partAttachmentPath.extension == 'docs'"
                  class="fp-text-document"></i>
                <i v-if="row.partAttachmentPath.extension == 'jpg' || row.partAttachmentPath.extension == 'png' || row.partAttachmentPath.extension == 'jpeg'"
                  class="fp-image"></i>
                <a title='View File' href="javascript:void(0)"
                  v-on:click="openDocument(row.partAttachmentPath.url, row.partAttachmentPath.extension)"
                  v-bind:key="'fileName' + index" style="color: #098de1;">
                  Attached File.{{ row.partAttachmentPath.extension }}
                </a>
                <button type="button" v-bind:key="'cancelBtn' + index"
                  v-on:click="deleteAttachment(index, 'partAttachment');" style="margin-left: 9px;">
                  <i class="fp-close" style="color: #e30000;"></i>
                </button>
              </template>
            </td>
            <td class="text-center valign-middle">
              <template v-if="rows.length != 1">
                <a href="javascript:void(0);" v-on:click="removeItem(index);"> <i class="fp-remove"></i> </a>
              </template>
              <template v-else>
                <span class="close-row"> _ </span>
              </template>
            </td>

          </tr>
        </tbody>
      </table>
    </div>
    <div class="btn-groups mb-4">
      <button type="submit" v-on:click.prevent="addRow()" class="btn btn-primary">
        <i class="fp-add"></i> Add another Part
      </button>
      <button type="button"
        v-on:click="updateLineItems()" class="btn btn-primary">
        <i class="fp-edit"></i> Edit
      </button>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { contractMixins } from "../../mixins/contractMixins";
import { commonMixins } from "../../mixins/commonMixins";

export default {
  name: "EvPartLineItemsSection",
  props: [
    "lineItemData",
    "claimId",
    "hideEditSection",
    "nonOemPartClaimAmountTotal",
    "canViewPartCalimedPrice"
  ],
  mixins: [commonMixins, contractMixins],
  data: () => ({
    rows: [],
    componentArr: [],
    totalClaimedAmount: 0,
    handlingTotalAmount: 0,
    netTotalAmount: 0,
  }),
  created() {
    this.populateData();
  },
  methods: {
    onSearchComponent(search, loading) {
      if (search.length > 2) {
        loading(true);
        this.location_error_msg = "";
        this.searchField(loading, search, 'component', '');
      }
    },
    populateDescription(index) {
      this.rows[index].description = this.rows[index].part.description;
      this.rows[index].require = true;
    },
    populatePartClaimedPrice(index) {
      this.rows[index].part_claimed_price = "$" + this.amountFormat(this.rows[index].part.price);
      this.calculateClaimAmount(index);
    },
    calculateClaimAmount(index) {
      // check if there is value in both quantity claimed and part claimed price
      var rowQtyClaimed = parseFloat(this.rows[index].qty_claimed);
      var rowClaimedPrice = this.rows[index].part_claimed_price;
      rowClaimedPrice = this.amountFormatToFloat(rowClaimedPrice);
      var rowHandling = parseFloat(this.rows[index].handling);
      var rowUserInputPrice = parseFloat(this.rows[index].user_input_price);
      this.rows[index].handling_amount = 0;
      this.rows[index].total = 0;
      this.rows[index].paid = 0;
      this.rows[index].processed = 0;


      if (
        rowQtyClaimed > 0
        &&
        typeof (rowQtyClaimed) === 'number'
        &&
        (rowClaimedPrice > 0 || rowUserInputPrice > 0)
        &&
        (typeof (rowClaimedPrice) === 'number' || typeof (rowUserInputPrice) === 'number')
      ) {
        if (rowUserInputPrice < rowClaimedPrice) {
          this.rows[index].attachmentRequired = false;
          this.rows[index].partAttachmentError = "";
          this.rows[index].processed = (rowQtyClaimed * rowUserInputPrice);
        } else {
          this.rows[index].attachmentRequired = true;
          if (this.rows[index].partAttachment == null) {
            this.rows[index].partAttachmentError = "Attachment is Required";
          } else {
            this.rows[index].partAttachmentError = "";
          }
          this.rows[index].processed = (rowQtyClaimed * rowClaimedPrice);
        }

        this.rows[index].handling_amount = (rowHandling / 100 * this.rows[index].processed);
        this.rows[index].total = this.rows[index].handling_amount + this.rows[index].processed;
      }

      this.rows[index].processed = "$" + this.amountFormat(this.rows[index].processed);
      this.calculateTotalClaimAmount();
    },
    calculateTotalClaimAmount() {
      this.totalClaimedAmount = 0;
      this.handlingTotalAmount = 0;
      for (let element of this.rows) {
        element.handling_amount = this.amountFormatToFloat(element.handling_amount);
        element.total = this.amountFormatToFloat(element.total);
        this.totalClaimedAmount += parseFloat(element.total);
        this.handlingTotalAmount += parseFloat(element.handling_amount);
        element.handling_amount = "$" + this.amountFormat(element.handling_amount);
        element.total = "$" + this.amountFormat(element.total);
        this.netTotalAmount = this.totalClaimedAmount + this.handlingTotalAmount;
      }
      this.netTotalAmount = this.netTotalAmount + this.nonOemPartClaimAmountTotal;
    },
    partAttachmentUpload(index, event) {
      this.rows[index].partAttachment = event.target.files[0];
      this.rows[index].partAttachmentError = "";
    },
    removeItem(index) {
      var self = this;
      if(this.rows[index].partAttachmentPath != null){
        this.deleteAttachment(index,"partAttachment"); // only call this function if the attachment is not null
      }
      if (this.rows.length > 1) {
        this.rows.splice(index, 1);
      }
      this.calculateTotalClaimAmount();
    },
    addRow() {
      var self = this;
      var index = this.rows.length - 1;
      var success = this.validatePartsRowData(index);
      if (success) {
        this.rows.push({
          part: "",
          part_type: "",
          qty_claimed: 0,
          processed_um: "",
          description: "",
          part_claimed_price: 0,
          user_input_price: 0,
          processed: 0,
          handling: 30,
          handling_amount:0,
          paid: 0,
          total: 0,
          core: "",
          part_number_error_msg: "",
          part_type_error_msg: "",
          quantity_claimed_error_msg: "",
          part_claimed_price_error_msg: "",
          item_id: "",
          require: false,
          partAttachment: null,
          partAttachmentError: "",
          partAttachmentPath: null,
          attachmentRequired: false,
          processed_part_quantity: 0,
          processed_part_price: 0,
          totalPartProcessedAmount: 0,
        });
      }
    },
    validatePartsRowData(index) {
      var success = true;

      this.clearRowErrorMessages(index);
      if (this.rows[index].part == null || this.rows[index].part == "") {
        success = false;
        this.rows[index].part_number_error_msg = "Part Number Required";
      }
      if (this.rows[index].qty_claimed == null || this.rows[index].qty_claimed == "") {
        success = false;
        this.rows[index].quantity_claimed_error_msg = "Quantity Claimed Required";
      }
      if (this.rows[index].part_claimed_price == null || this.rows[index].part_claimed_price == "") {
        success = false;
        this.rows[index].part_claimed_price_error_msg = "Part Claimed Price Required";
      }
      if (this.rows[index].attachmentRequired && this.rows[index].partAttachmentPath == null){
        success = false;
        this.rows[index].partAttachmentError = "Attachment is required and needs to be uploaded";
      }
      return success;
    },
    clearRowErrorMessages(index) {
      this.rows[index].part_number_error_msg = "";
      this.rows[index].part_type_error_msg = "";
      this.rows[index].quantity_claimed_error_msg = "";
      this.rows[index].part_claimed_price_error_msg = "";
      this.rows[index].partAttachmentError = "";
    },
    populateData(){
      this.rows = [];
        for (const element of this.lineItemData) {
          element.part_claimed_price = "$" + this.amountFormat(element.part_claimed_price);
          element.processed = "$" + this.amountFormat(element.processed);
          element.handling_amount = "$" + this.amountFormat(element.handling_amount);
          element.total = "$" + this.amountFormat(element.total);
          this.rows.push(element);
        }
      console.log("rows before calculation =>",this.rows);
    },
    prepareDataForUpdating(){
      this.rows.forEach((row) => {
        delete row.partAttachment;
      });
      const lineItemsData = {
        rows: this.rows,
        totalClaimedAmount: this.totalClaimedAmount,
        handlingTotalAmount: this.handlingTotalAmount,
        netTotalAmount: this.netTotalAmount,
        attachmentRequired: this.attachmentRequired,
        claimId: this.claimId,
      }
      return lineItemsData;
    },
    updateLineItems(){
      var self = this;
      const lineItemData = this.prepareDataForUpdating();
      self.$parent.loading = true;
      $.ajax({
          url: process.env.ROOT_API + "/update/part-line-items",
          type: "POST",
          data: {
            lineItemData: lineItemData,
          },
          headers: this.ajxHeaders,
          dataType: "json",
          cors: true,
          success: function (data) {
            self.$parent.loading = false;
            if (data.status == "success") {
              self.hideEditSection("part_line_items");
            } else {
              console.log("Error");
            }
          },
          error: function (jqXHR, exception) {
            self.$parent.loading = false;
            console.log("ERRORRRR");
          },
        });
    },
    calculateProcessedLineItemAmount(index) {
      // check if there is value in both quantity claimed and part claimed price
      let qty = parseFloat(this.rows[index].processed_part_quantity);
      let price = this.rows[index].processed_part_price;
      // price = this.amountFormatToFloat(price);
      if(qty > 0 && price >0){

        let handlingPercentage = parseFloat(this.rows[index].handling);
        // let totalPartProcessedAmount = 0;
        // let processedTotal = 0;
        let totalPartProcessedAmount = qty * price;
        let processedHandlingAmount = (handlingPercentage / 100) * totalPartProcessedAmount;
         let processedTotal = processedHandlingAmount + totalPartProcessedAmount;

        this.rows[index].totalPartProcessedAmount = "$" + this.amountFormat(totalPartProcessedAmount);
        this.rows[index].processed_handling_amount = "$" + this.amountFormat(processedHandlingAmount);
        this.rows[index].processed_total = "$" + this.amountFormat(processedTotal);
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/warrantyClaimTabs/EvPartLineItemsSection.vue